import { GridDataService } from './grid-data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MessageHandlerService } from '../../utility/message-handler.service';
import { ColumnSettings } from '../../model/column-settings';
import { remove } from 'lodash';
import { GridQueryUtils } from '../../utility/grid-query-utils';

@Injectable()
export class TaskListService extends GridDataService
{
    public translateService: TranslateService;

    constructor(http: HttpClient, translate: TranslateService, messageHandlerService: MessageHandlerService)
    {
        super(http, '/tasks', translate, messageHandlerService);
        this.translateService = translate;
    }

    public setDefaultColumnsSetting(filterState: string, filterColumns: string, defaultPageSize: number,
        communityEnabled: boolean = null): Promise<any[]>
    {
        return new Promise((resolve: any) =>
        {
            this.translateService.get(['TASK', 'CASE', 'CHANNEL', 'REFERRED-ORGANIZATION', 'REFERRED-SERVICE', 'CHANNEL-WORKFLOW-STATUS',
                'ASSIGNED-TO', 'OPENED-ON', 'DUE-DATE', 'CLOSED-ON', 'DAYS-ON-LIST', 'EVENT-TYPE', 'PRIORITY'])
                .subscribe({
                    next: (res) =>
                    {
                        const columnsConfig: ColumnSettings[] = [
                            {
                                field: 'name',
                                title: res.TASK,
                                titleKeys: ['TASK'],
                                width: 140,
                                sortable: true,
                                filterable: true,
                                hidden: false,
                                class: 'emphasizedLabel pointer font-weight-bold'
                            },
                            {
                                field: 'caseName',
                                title: res.CASE,
                                titleKeys: ['CASE'],
                                width: 80,
                                sortable: true,
                                filterable: true,
                                hidden: false
                            },
                            {
                                field: 'channel',
                                title: res.CHANNEL,
                                titleKeys: ['CHANNEL'],
                                width: 110,
                                sortable: true,
                                filterable: true,
                                hidden: false
                            },
                            {
                                field: 'eventReferral.referredToOrganizationName',
                                title: res['REFERRED-ORGANIZATION'],
                                titleKeys: ['REFERRED-ORGANIZATION'],
                                width: 50,
                                sortable: true,
                                filterable: true,
                                hidden: false
                            },
                            {
                                field: 'eventReferral.referredServiceName',
                                title: res['REFERRED-SERVICE'],
                                titleKeys: ['REFERRED-SERVICE'],
                                width: 50,
                                sortable: true,
                                filterable: true,
                                hidden: true
                            },
                            {
                                field: 'channelWorkflowStatus.displayName',
                                title: res['CHANNEL-WORKFLOW-STATUS'],
                                titleKeys: ['CHANNEL-WORKFLOW-STATUS'],
                                width: 80,
                                sortable: true,
                                filterable: true,
                                hidden: false
                            },
                            {
                                field: 'assigneeName',
                                title: res['ASSIGNED-TO'],
                                titleKeys: ['ASSIGNED-TO'],
                                width: 90,
                                sortable: true,
                                filterable: true,
                                hidden: false
                            },
                            {
                                field: 'openedOn',
                                title: res['OPENED-ON'],
                                titleKeys: ['OPENED-ON'],
                                width: 95,
                                sortable: true,
                                filterable: true,
                                hidden: false,
                                filter: 'date',
                                format: '{0:d}'
                            },
                            {
                                field: 'dueDate',
                                title: res['DUE-DATE'],
                                titleKeys: ['DUE-DATE'],
                                width: 80,
                                sortable: true,
                                filterable: true,
                                hidden: false,
                                filter: 'date',
                                format: '{0:d}'
                            },
                            {
                                field: 'closedOn',
                                title: res['CLOSED-ON'],
                                titleKeys: ['CLOSED-ON'],
                                width: 80,
                                sortable: true,
                                filterable: true,
                                hidden: true,
                                filter: 'date',
                                format: '{0:d}'
                            },
                            {
                                field: 'daysOnList',
                                title: res['DAYS-ON-LIST'],
                                titleKeys: ['DAYS-ON-LIST'],
                                width: 90,
                                sortable: true,
                                filterable: true,
                                hidden: false,
                                filter: 'numeric',
                                format: '{0:n}'
                            },
                            {
                                field: 'eventType',
                                title: res['EVENT-TYPE'],
                                titleKeys: ['EVENT-TYPE'],
                                width: 30,
                                columnMenu: false,
                                sortable: false,
                                filterable: false,
                                hidden: false,
                                class: 'text-center'
                            },
                            {
                                field: 'priority',
                                title: res.PRIORITY,
                                titleKeys: ['PRIORITY'],
                                width: 49,
                                columnMenu: false,
                                sortable: true,
                                filterable: true,
                                hidden: false,
                                class: 'text-center'
                            }
                        ];

                        // Set grid columns
                        const loadedColumns = GridQueryUtils.setBaseColumnsSetting(this.translateService,
                            filterColumns, columnsConfig);

                        // Removed columns if option not enabled (for setting edit, communityEnabled is null)
                        if (communityEnabled !== null && !communityEnabled)
                        {
                            remove(loadedColumns, (x: ColumnSettings) =>
                                x.field === 'eventReferral.referredToOrganizationName' || x.field === 'eventReferral.referredServiceName');
                        }

                        resolve({
                            state: filterState ? JSON.parse(filterState) : { skip: 0, group: [], sort: [], take: defaultPageSize },
                            columns: loadedColumns
                        });
                    }
                });
        });
    }
}
